import React from 'react'
import UpArrow from '@mortgage-pos/ui/assets/arrow-up.svg'
import DownArrow from '@mortgage-pos/ui/assets/arrow-down.svg'
import DocumentIcon from '@mortgage-pos/ui/assets/save-icon.svg'
import { LoanOfficerCard } from './LoanOfficerPricingCard'

interface CardCopy {
  subtitle: String
  subhead0: String
  subhead1: String
  body: String
}

export interface Props {
  title?: String
  lockInTitle?: String
  lockInSubTitle?: String
  lockInBody?: String
  pointsCard?: CardCopy
  creditsCard?: CardCopy
  onTalkToExpertClick?: () => void
}

const defaultProps = {
  title: 'What are points and credits?',
  lockInTitle: 'Time to lock in a rate',
  lockInSubTitle: 'What does it mean to lock in a rate?',
  lockInBody:
    'Locking a rate means that the lenders we work with will honor the rate and cost of the rate you select here for 30 days. This protects you from rate fluctuations in the market which happen multiple times a day. ',
  pointsCard: {
    subtitle: 'Points',
    subhead0: 'Higher closing costs',
    subhead1: 'Lower interest rate',
    body: "With points, you pay more up front in exchange for a lower interest rate. Paying points will help you save more money the longer you stay in your home because you'll pay less interest over the life of your loan.",
  },
  creditsCard: {
    subtitle: 'Credits',
    subhead0: 'Lower closing costs',
    subhead1: 'Higher interest rate',
    body: 'With credits, you pay less up front in exchange for a higher interest rate. If you plan on moving within the next few years, consider going with credits since interest saved on a lower rate might not be offset by the time you sell your property.',
  },
}

export const EducationSection: React.FC<Props> = ({
  title = defaultProps.title,
  lockInTitle = defaultProps.lockInTitle,
  lockInSubTitle = defaultProps.lockInSubTitle,
  lockInBody = defaultProps.lockInBody,
  pointsCard = defaultProps.pointsCard,
  creditsCard = defaultProps.creditsCard,
  onTalkToExpertClick,
}) => (
  <>
    <div className="education-section">
      <h3 className="education-section__title">{title}</h3>
      <div className="education-section__call-out-container">
        <div className="education-section__card">
          <h4 className="education-section__card-subtitle">
            {pointsCard.subtitle}
          </h4>
          <div className="education-section__arrow-container">
            <div className="education-section__arrow">
              <img className="" src={UpArrow} alt="Arrow up icon" />
              <h5 className="education-section__card-subhead">
                {pointsCard.subhead0}
              </h5>
            </div>
            <div className="education-section__arrow">
              <img className="" src={DownArrow} alt="Arrow down icon" />
              <h5 className="education-section__card-subhead">
                {pointsCard.subhead1}
              </h5>
            </div>
          </div>
          <p className="education-section__card-body">{pointsCard.body}</p>
        </div>
        <div className="education-section__divider">
          <div className="education-section__vertical-line --top" />
          <div className="education-section__circle">
            <span>VS</span>
          </div>
          <div className="education-section__vertical-line --bottom" />
        </div>

        <div className="education-section__card">
          <h4 className="education-section__card-subtitle">
            {creditsCard.subtitle}
          </h4>
          <div className="education-section__arrow-container">
            <div className="education-section__arrow">
              <img className="" src={UpArrow} alt="Arrow up icon" />
              <h5 className="education-section__card-subhead">
                {creditsCard.subhead0}
              </h5>
            </div>
            <div className="education-section__arrow">
              <img src={DownArrow} alt="Arrow down icon" />
              <h5 className="education-section__card-subhead">
                {creditsCard.subhead1}
              </h5>
            </div>
          </div>
          <p className="education-section__card-body">{creditsCard.body}</p>
        </div>
      </div>
    </div>
    <div className="education-section">
      <h3 className="education-section__title">{lockInTitle}</h3>
      <div className="education-section__lockin-container">
        <div className="education-section__image-container">
          <img
            className="education-section__lockin-image"
            src={DocumentIcon}
            alt="icon of a document"
          />
        </div>
        <div className="education-section__lockin-copy">
          <h4 className="education-section__lockin-subtitle">
            {lockInSubTitle}
          </h4>
          <p className="education-section__lockin-body">{lockInBody}</p>
        </div>
      </div>
      <LoanOfficerCard onCtaClick={onTalkToExpertClick} />
    </div>
  </>
)
